"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResourceBadgeWrapper = exports.UserAvatarSubheading = exports.UserAvatarName = exports.UserAvatarTextWrapper = exports.UserAvatarPlaceholder = exports.UserAvatarImage = exports.UserAvatarWrapper = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _StyledLink = _interopRequireDefault(require("./StyledLink"));

var _StyledLayout = require("./StyledLayout");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var UserAvatarWrapper = _styledComponents["default"].div.withConfig({
  displayName: "StyledUserAvatar__UserAvatarWrapper",
  componentId: "sc-1q2i94h-0"
})(["display:flex;align-items:center;position:relative;", " ", " ", " ", " ", " ", ""], function (props) {
  return props.size === 'xsmall' && (0, _styledComponents.css)(["min-width:25px;"]);
}, function (props) {
  return props.size === 'small' && (0, _styledComponents.css)(["min-width:32px;"]);
}, function (props) {
  return props.size === 'medium' && (0, _styledComponents.css)(["min-width:40px;"]);
}, function (props) {
  return props.size === 'large' && (0, _styledComponents.css)(["min-width:48px;"]);
}, function (props) {
  return props.size === 'xlarge' && (0, _styledComponents.css)(["min-width:64px;"]);
}, function (props) {
  return props.size === 'xxlarge' && (0, _styledComponents.css)(["min-width:100px;"]);
});

exports.UserAvatarWrapper = UserAvatarWrapper;

var UserAvatarImage = _styledComponents["default"].img.withConfig({
  displayName: "StyledUserAvatar__UserAvatarImage",
  componentId: "sc-1q2i94h-1"
})(["border-radius:50%;width:56px;height:56px;overflow:hidden;", " ", " ", " ", " ", " ", " ", " ", ""], function (props) {
  return props.size === 'xsmall' && (0, _styledComponents.css)(["width:25px;height:25px;margin-right:8px;"]);
}, function (props) {
  return props.size === 'small' && (0, _styledComponents.css)(["width:32px;height:32px;"]);
}, function (props) {
  return props.size === 'medium' && (0, _styledComponents.css)(["width:40px;height:40px;"]);
}, function (props) {
  return props.size === 'large' && (0, _styledComponents.css)(["width:48px;height:48px;"]);
}, function (props) {
  return props.size === 'xlarge' && (0, _styledComponents.css)(["width:64px;height:64px;"]);
}, function (props) {
  return props.size === 'xxlarge' && (0, _styledComponents.css)(["width:100px;height:100px;"]);
}, function (props) {
  return props.square && (0, _styledComponents.css)(["border-radius:4px;"]);
}, function (props) {
  return props.border === 'white' && (0, _styledComponents.css)(["border:1px solid ", ";"], props.theme.borderColorWhite);
});

exports.UserAvatarImage = UserAvatarImage;
var UserAvatarPlaceholder = (0, _styledComponents["default"])(UserAvatarImage).withConfig({
  displayName: "StyledUserAvatar__UserAvatarPlaceholder",
  componentId: "sc-1q2i94h-2"
})(["background-color:", ";"], function (props) {
  return props.theme.bgColorTint;
});
exports.UserAvatarPlaceholder = UserAvatarPlaceholder;

var UserAvatarTextWrapper = _styledComponents["default"].div.withConfig({
  displayName: "StyledUserAvatar__UserAvatarTextWrapper",
  componentId: "sc-1q2i94h-3"
})(["display:flex;flex-direction:column;flex:1;overflow:hidden;align-items:flex-start;margin-left:", ";"], function (props) {
  return props.size === 'xsmall' && '0' || props.size === 'small' && '0' || props.theme.spacingSm;
});

exports.UserAvatarTextWrapper = UserAvatarTextWrapper;
var UserAvatarName = (0, _styledComponents["default"])(_StyledLink["default"]).withConfig({
  displayName: "StyledUserAvatar__UserAvatarName",
  componentId: "sc-1q2i94h-4"
})(["color:", ";font-size:", ";", " ", ""], function (props) {
  return props.theme.fontColorDefault;
}, function (props) {
  return props.topnav && props.theme.fontSizeTopnav || props.theme.fontSizeBody;
}, function (props) {
  return props.size === 'xsmall' && (0, _styledComponents.css)(["font-size:", ";"], props.theme.fontSizeBodySm);
}, function (props) {
  return props.noHover && (0, _styledComponents.css)(["&:hover{color:", ";cursor:default;}"], props.theme.fontColorDefault);
});
exports.UserAvatarName = UserAvatarName;
var UserAvatarSubheading = (0, _styledComponents["default"])(_StyledLink["default"]).withConfig({
  displayName: "StyledUserAvatar__UserAvatarSubheading",
  componentId: "sc-1q2i94h-5"
})(["color:", ";font-size:", ";", " ", ""], function (props) {
  return props.dark && props.theme.fontColorDark || props.theme.fontColorMedium;
}, function (props) {
  return props.theme.fontSizeBodySm;
}, function (props) {
  return props.noHover && (0, _styledComponents.css)(["&:hover{color:", ";}"], props.dark && props.theme.fontColorDark || props.theme.fontColorMedium);
}, function (props) {
  return props.singleLine && (0, _styledComponents.css)(["white-space:nowrap;text-overflow:ellipsis;overflow-x:hidden;"]);
});
exports.UserAvatarSubheading = UserAvatarSubheading;
var ResourceBadgeWrapper = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "StyledUserAvatar__ResourceBadgeWrapper",
  componentId: "sc-1q2i94h-6"
})(["border-radius:50%;width:24px;height:24px;right:0;bottom:0;background-color:", ";"], function (props) {
  return props.theme.positiveColor;
});
exports.ResourceBadgeWrapper = ResourceBadgeWrapper;